export default function CertificationBadges() {
  return (
    <section className="bg-gradient-to-r from-blue-900 to-blue-800 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12">
          {/* Licensed Insurance Advisor - Now First */}
          <div className="flex items-center gap-4 bg-white/10 backdrop-blur-sm rounded-xl px-6 py-4 border border-white/20 hover:bg-white/15 transition-all">
            <div className="bg-white rounded-lg p-3 shadow-lg">
              <svg className="w-12 h-12 md:w-16 md:h-16 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
            </div>
            <div>
              <p className="font-bold text-white text-sm md:text-base">IRDAI-certified insurance advisor </p>
              <p className="text-green-200 text-xs md:text-sm">- Health Insurance</p>
              <p className="text-green-200 text-xs md:text-sm">- LifeInsurance</p>
              <p className="text-green-200 text-xs md:text-sm">- General Insurance</p>
            </div>
          </div>

          {/* AMFI Certification - Now Second */}
          <div className="flex items-center gap-4 bg-white/10 backdrop-blur-sm rounded-xl px-6 py-4 border border-white/20 hover:bg-white/15 transition-all">
            <div className="bg-white rounded-lg p-3 shadow-lg">
              <img 
                src="/amfi-logo.png" 
                alt="AMFI Logo" 
                className="h-12 w-12 md:h-16 md:w-16 object-contain"
                onError={(e) => {
                  // Fallback if image not found
                  e.currentTarget.style.display = 'none';
                  const parent = e.currentTarget.parentElement;
                  if (parent) {
                    parent.innerHTML = `
                      <svg class="w-12 h-12 md:w-16 md:h-16 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                      </svg>
                    `;
                  }
                }}
              />
            </div>
            <div>
              <p className="font-bold text-white text-sm md:text-base">AMFI Registered Distributor</p>
              <p className="text-blue-200 text-xs md:text-sm">ARN: 349565</p>
            </div>
          </div>

          {/* Trusted Badge */}
          <div className="flex items-center gap-4 bg-white/10 backdrop-blur-sm rounded-xl px-6 py-4 border border-white/20 hover:bg-white/15 transition-all">
            <div className="bg-white rounded-lg p-3 shadow-lg">
              <svg className="w-12 h-12 md:w-16 md:h-16 text-yellow-600" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
            </div>
            <div>
              <p className="font-bold text-white text-sm md:text-base">Trusted by 1000+ Families</p>
              <p className="text-yellow-200 text-xs md:text-sm">₹100Cr+ Coverage</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
